import styles from "./App.module.css";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import DrawOnDemo from "./components/DrawOnDemo/DrawOnDemo";
import Experience from "./components/Experience/Experience";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Projects from "./components/Projects/Projects";
import useSmoothScroll from "./hooks/useSmoothScroll";
import useTheme from "./hooks/useTheme";

function App() {
  const [theme, toggleTheme] = useTheme();
  useSmoothScroll();

  return (
    <div className={styles.App}>
      <div className={styles.ambient} aria-hidden="true" />
      <div className={styles.grain} aria-hidden="true" />
      <Navbar theme={theme} onToggleTheme={toggleTheme} />
      <main className={styles.mainContent}>
        <Home theme={theme} />
        <About />
        <Experience />
        <Projects />
        <DrawOnDemo theme={theme} />
      </main>
      <Contact />
    </div>
  );
}

export default App;